import {Component, Input} from '@angular/core';
import {Unit} from '../../dashboard/monitoring/unit';
import {Observable} from 'rxjs';
import {RouteLibraryService} from '../../route/route-library.service';
import {timestampToDateTime} from '../../utility/timestamp-functions';
import {RouteLibraryEntities} from '../../route/route-library-entity';

@Component({
  selector: 'app-unit-battery',
  templateUrl: './unit-battery.component.html',
})
export class UnitBatteryComponent {
  protected readonly RouteLibraryEntities = RouteLibraryEntities;
  protected readonly timestampToDateTime = timestampToDateTime;
  @Input() unitObservable: Observable<Unit>;

  constructor(
    public routeLibrary: RouteLibraryService,
  ) {
  }

  formatQrCodeLink(unit: Unit, regNumber: string): string {
    const downloadAppLink = unit.unitModel.project.download_app_link;
    let link = regNumber.toString();
    if (downloadAppLink) {
      link = downloadAppLink.toString()
        + '?id=' + regNumber.toString();
    }
    return link;
  }
}
